import { Directive, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { DatePickerComponent } from '@shared/date-picker/date-picker.component';
import { ProjectSection } from '../models/access.models';
import { AccessService } from '../services/access.service';

/**
 * Directive: PermDatePickerDirective
 *
 * Автоматически блокирует (устанавливает `isLock=true`) компонент `app-date-picker`
 * если текущий пользователь не имеет права `<section>:edit`.
 * Работает аналогично уже существующим директивам `PermSelectDirective`,
 * `PermFormDirective`, `PermChipDirective`, `PermRadioDirective`.
 * Секция берётся из `data['section']` маршрута.
 * Директива подключается через `AccessUiModule` и применяется к каждому
 * `app-date-picker` в шаблонах без дополнительного кода.
 */
@Directive({ selector: 'app-date-picker' })
export class PermDatePickerDirective implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Optional() @Self() private readonly _dp: DatePickerComponent,
    private readonly _route: ActivatedRoute,
    private readonly _access: AccessService,
  ) {}

  ngOnInit(): void {
    const data = this._route.snapshot.data ?? {};
    const section = data['section'] as ProjectSection | undefined;
    if (!section || data['skipPermDisable'] || !this._dp) return;

    this._access
      .can$(section, 'edit')
      .pipe(takeUntil(this._destroy$))
      .subscribe(canEdit => {
        this._dp.isLock = !canEdit;
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
